module.exports = __webpack_public_path__ + "static/media/8.a1a1baf5.png";